import { useMemo } from 'react';

const useSocialProviders = ({ components = [] } = { components: [] }) => {
  return useMemo(
    () => components.find(({ type }) => type === 'SOCIAL_LOGIN')?.providers ?? [],
    [components],
  );
};

export default useSocialProviders;
